export default "/images/vendor/flag-icons/flags/4x3/bi.svg?5d3435104d6a6e67937cde02313d2d31";